<template>
    <!-- Header -->
    <div class="header d-flex align-items-center">

    <!-- Logo -->
    <div class="header-left active">
        <a href="index.html" class="logo logo-normal">
            <img src="/assets/img/otobonik-logo.png" alt="">
        </a>
        <a href="index.html" class="logo logo-white">
            <img src="/assets/img/otobonik-logo.png" alt="">
        </a>
        <a href="index.html" class="logo-small">
            <img src="/assets/img/otobonik-small.png" alt="">
        </a>
        <a id="toggle_btn" href="javascript:void(0);">
            <i data-feather="chevrons-left" class="feather-16"></i>
        </a>
    </div>
    <!-- /Logo -->

    <a id="mobile_btn" class="mobile_btn" href="#sidebar">
        <span class="bar-icon">
            <span></span>
            <span></span>
            <span></span>
        </span>
    </a>

    <!-- Header Menu -->
    <div class="header-right ms-auto">
      <ul class="nav user-menu">

        <!-- Search -->
<!--        <li class="nav-item nav-searchinputs">-->
<!--            <div class="top-nav-search">-->
<!--                <a href="javascript:void(0);" class="responsive-search">-->
<!--                    <i class="fa fa-search"></i>-->
<!--                </a>-->
<!--                <form action="#" class="dropdown">-->
<!--                    <div class="searchinputs dropdown-toggle" id="dropdownMenuClickable"-->
<!--                        data-bs-toggle="dropdown" data-bs-auto-close="false">-->
<!--                        <input type="text" placeholder="Search">-->
<!--                        <div class="search-addon">-->
<!--                            <span><i data-feather="x-circle" class="feather-14"></i></span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="dropdown-menu search-dropdown" aria-labelledby="dropdownMenuClickable">-->
<!--                        <div class="search-info">-->
<!--                            <h6><span><i data-feather="search" class="feather-16"></i></span>Recent Searches-->
<!--                            </h6>-->
<!--                            <ul class="search-tags">-->
<!--                                <li><a href="javascript:void(0);">Products</a></li>-->
<!--                                <li><a href="javascript:void(0);">Sales</a></li>-->
<!--                                <li><a href="javascript:void(0);">Applications</a></li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                        <div class="search-info">-->
<!--                            <h6><span><i data-feather="help-circle" class="feather-16"></i></span>Help</h6>-->
<!--                            <p>How to Change Product Volume from 0 to 200 on Inventory management</p>-->
<!--                            <p>Change Product Name</p>-->
<!--                        </div>-->
<!--                        <div class="search-info">-->
<!--                            <h6><span><i data-feather="user" class="feather-16"></i></span>Customers</h6>-->
<!--                            <ul class="customers">-->
<!--                                <li>-->
<!--                                    <a href="javascript:void(0);">Aron Varu<img src="/assets/img/profiles/avator1.jpg" alt="" class="img-fluid"></a>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <a href="javascript:void(0);">Jonita<img src="/assets/img/profiles/avatar-01.jpg" alt="" class="img-fluid"></a>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <a href="javascript:void(0);">Aaron<img src="/assets/img/profiles/avatar-10.jpg" alt="" class="img-fluid"></a>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </form>-->
<!--            </div>-->
<!--        </li>-->
        <!-- /Search -->

        <li class="nav-item pos-nav">
          <router-link v-if="isPosPage" to="/" class="btn btn-dark btn-md d-inline-flex align-items-center">
            <i class="ti ti-dashboard me-1"></i>Dashboard
          </router-link>

          <router-link v-else  to="/pos" class="btn btn-dark btn-md d-inline-flex align-items-center">
            <i class="ti ti-device-laptop me-1"></i>POS
          </router-link>
        </li>

        <!-- Select Store -->
        <li class="nav-item">
          <div class="d-flex align-items-center select-store-wrapper">
            <VueSelect2
              v-model="selectedStoreId"
              :options="formattedStores"
              :settings="{
                placeholder: $t('select_store'),
                allowClear: true,
                width: '220px'
              }"
              @update:modelValue="onStoreChange"
              class="form-control select-store-select"
            />
          </div>
        </li>
        <!-- /Select Store -->

<!--        &lt;!&ndash; Select Store &ndash;&gt;-->
<!--        <li class="nav-item dropdown has-arrow main-drop select-store-dropdown">-->
<!--          <a href="javascript:void(0);" class="dropdown-toggle nav-link select-store" data-bs-toggle="dropdown"> -->
<!--            <span class="user-info"> <span class="user-letter">-->
<!--              <img src="/assets/img/store/store-01.png" alt="Store Logo" class="img-fluid">-->
<!--            </span>-->
<!--              <span class="user-detail">-->
<!--                <span class="user-name">Select Store</span>-->
<!--              </span> -->
<!--            </span>-->
<!--          </a>-->
<!--          <div class="dropdown-menu dropdown-menu-right">-->
<!--            <a href="javascript:void(0);" class="dropdown-item">-->
<!--              <img src="/assets/img/store/store-01.png" alt="Store Logo" class="img-fluid"> Grocery Alpha </a>-->
<!--            <a href="javascript:void(0);" class="dropdown-item">-->
<!--              <img src="/assets/img/store/store-02.png" alt="Store Logo" class="img-fluid"> Grocery Apex </a>-->
<!--            <a href="javascript:void(0);" class="dropdown-item">-->
<!--              <img src="/assets/img/store/store-03.png" alt="Store Logo" class="img-fluid"> Grocery Bevy </a>-->
<!--            <a href="javascript:void(0);" class="dropdown-item">-->
<!--              <img src="/assets/img/store/store-04.png" alt="Store Logo" class="img-fluid"> Grocery Eden </a>-->
<!--          </div>-->
<!--        </li>-->
<!--        &lt;!&ndash; /Select Store &ndash;&gt;-->

        <!-- Language Switcher -->
        <li class="nav-item dropdown has-arrow flag-nav nav-item-box">
          <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button">
            <img :src="currentFlag" :alt="currentLanguage" class="img-fluid">
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <a
              v-for="(lang, code) in languages"
              :key="code"
              href="#"
              class="dropdown-item"
              :class="{ active: currentLanguage === lang.name }"
              @click.prevent="changeLanguage(code)"
            >
              <img :src="lang.flag" :alt="lang.name" height="16"> {{ lang.name }}
            </a>
          </div>
        </li>
        <!-- /Language Switcher -->

<!--        <li class="nav-item nav-item-box">-->
<!--            <a href="javascript:void(0);" id="btnFullscreen">-->
<!--                <i data-feather="maximize"></i>-->
<!--            </a>-->
<!--        </li>-->
<!--        <li class="nav-item nav-item-box">-->
<!--            <a href="email.html">-->
<!--                <i data-feather="mail"></i>-->
<!--                <span class="badge rounded-pill">1</span>-->
<!--            </a>-->
<!--        </li>-->
        <!-- Notifications -->
<!--        <li class="nav-item dropdown nav-item-box">-->
<!--            <a href="javascript:void(0);" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">-->
<!--                <i data-feather="bell"></i><span class="badge rounded-pill">2</span>-->
<!--            </a>-->
<!--            <div class="dropdown-menu notifications">-->
<!--                <div class="topnav-dropdown-header">-->
<!--                    <span class="notification-title">Notifications</span>-->
<!--                    <a href="javascript:void(0)" class="clear-noti"> Clear All </a>-->
<!--                </div>-->
<!--                <div class="noti-content">-->
<!--                    <ul class="notification-list">-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-02.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">John Doe</span> added-->
<!--                                            new task <span class="noti-title">Patient appointment booking</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">4 mins ago</span>-->
<!--                                        </p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-03.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Tarah Shropshire</span>-->
<!--                                            changed the task name <span class="noti-title">Appointment booking-->
<!--                                            with payment gateway</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">6 mins ago</span>-->
<!--                                        </p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-06.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Misty Tison</span>-->
<!--                                            added <span class="noti-title">Domenic Houston</span> and <span-->
<!--                                            class="noti-title">Claire Mapes</span> to project <span-->
<!--                                            class="noti-title">Doctor available module</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">8 mins ago</span>-->
<!--                                        </p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-17.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Rolland Webber</span>-->
<!--                                            completed task <span class="noti-title">Patient and Doctor video conferencing</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">12 mins ago</span></p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li class="notification-message">-->
<!--                            <a href="activities.html">-->
<!--                                <div class="media d-flex">-->
<!--                                    <span class="avatar flex-shrink-0">-->
<!--                                        <img alt="" src="/assets/img/profiles/avatar-13.jpg">-->
<!--                                    </span>-->
<!--                                    <div class="media-body flex-grow-1">-->
<!--                                        <p class="noti-details"><span class="noti-title">Bernardo Galaviz</span>-->
<!--                                            added new task <span class="noti-title">Private chat module</span>-->
<!--                                        </p>-->
<!--                                        <p class="noti-time"><span class="notification-time">2 days ago</span></p>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--                <div class="topnav-dropdown-footer">-->
<!--                    <a href="activities.html">View all Notifications</a>-->
<!--                </div>-->
<!--            </div>-->
<!--        </li>-->
        <!-- /Notifications -->

<!--        <li class="nav-item nav-item-box">-->
<!--            <a href="general-settings.html"><i data-feather="settings"></i></a>-->
<!--        </li>-->

        <li class="nav-item dropdown has-arrow main-drop">
            <a href="javascript:void(0);" class="dropdown-toggle nav-link userset" data-bs-toggle="dropdown">
                <span class="user-info">
                    <span class="user-letter">
                        <img src="/assets/img/profiles/default-user.jpeg" alt="" class="img-fluid">
                    </span>
                    <span class="user-detail">
                        <span class="user-name">{{ username }}</span>
                        <span class="user-role">{{ role }}</span>
                    </span>
                </span>
            </a>
            <div class="dropdown-menu menu-drop-user">
                <div class="profilename">
                    <div class="profileset">
                        <span class="user-img"><img src="/assets/img/profiles/default-user.jpeg" alt="">
                            <span class="status online"></span></span>
                        <div class="profilesets">
                            <h6>{{ user?.username }}</h6>
                            <h5>{{ user?.role }}</h5>
                        </div>
                    </div>
                    <hr class="m-0">
<!--                    <a class="dropdown-item" href="profile.html"> <i class="me-2" data-feather="user"></i> My Profile</a>-->
<!--                    <a class="dropdown-item" href="general-settings.html"><i class="me-2" data-feather="settings"></i>Settings</a>-->

                    <!-- Change Password -->
                    <router-link class="dropdown-item" to="/change/password/">
                      <i class="ti ti-lock me-2"></i>
                      Change Password
                    </router-link>

                    <hr class="m-0">
                    <a class="dropdown-item logout pb-0" href="#" @click.prevent="logout"><img src="/assets/img/icons/log-out.svg" class="me-2" alt="img">Logout</a>
                </div>
            </div>
        </li>
    </ul>
    </div>
    <!-- /Header Menu -->

    <!-- Mobile Menu -->
    <div class="dropdown mobile-user-menu">
        <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
        <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" href="profile.html">My Profile</a>
            <a class="dropdown-item" href="general-settings.html">Settings</a>
            <a class="dropdown-item" href="signin.html">Logout</a>
        </div>
    </div>
    <!-- /Mobile Menu -->
  </div>
  <!-- /Header -->
</template>

<script>
  import apiUrls from "@/urls";
  import VueSelect2 from "vue3-select2-component";

  export default {
    components: {
      VueSelect2
    },

    name: "Header",

    data() {
      return {
        user: null,
        currentLanguage: "English",
        currentFlag: "/assets/img/flags/us.png",
        languages: {
          en: { name: "English", flag: "/assets/img/flags/us.png" },
          bn: { name: "Bangla", flag: "/assets/img/flags/bd.png" },
        },
        selectedStoreId: null,
        stores: [],
      };
    },

    computed: {
      username() {
        return this.user?.username || "Guest";
      },

      role() {
        return this.user?.role || "";
      },

      formattedStores() {
        return this.stores.map(store => ({
          id: String(store.id),
          text: store.name
        }));
      },

      isPosPage() {
        return this.$route.path.startsWith("/pos");
      }
    },

    async created() {
      try {
        if (localStorage.getItem("auth_token")) {
          await this.fetchUser();
        }

        const res = await this.$axios.get(apiUrls.stores.get);
        this.stores = res.data;

        const savedStoreId = localStorage.getItem("store_id");

        // Normal user
        if (this.user?.store) {
          this.selectedStoreId = this.user.store;
          localStorage.setItem("store_id", this.user.store);
        }

        // Admin
        else if (this.stores.length > 0) {
          const validSavedStore = this.stores.find(
            s => s.id == savedStoreId
          );

          if (validSavedStore) {
            this.selectedStoreId = validSavedStore.id;
          } else {
            this.selectedStoreId = this.stores[0].id;
          }

          localStorage.setItem("store_id", this.selectedStoreId);
        }

      } catch (err) {
        if (err.response?.status === 401) {
          this.logout();
        } else {
          console.error("Header init error:", err);
        }
      }
    },

    methods: {
      async fetchUser() {
        try {
          const res = await this.$axios.get(apiUrls.login_user.get);
          this.user = res.data
        } catch (e) {
          console.error('User fetch failed', e)
        }
      },

      logout() {
          localStorage.removeItem("auth_token");
          this.$router.push("/login");
      },

      async changeLanguage(code) {
        this.currentLanguage = this.languages[code].name;
        this.currentFlag = this.languages[code].flag;

        try {
          // Call Django API to update the language
          await this.$axios.post("user/switch-language/", { language: code });

          // Save selected language in localStorage
          localStorage.setItem("selectedLanguage", code);
          localStorage.setItem("selectedFlag", this.languages[code].flag);

          // Dynamically change the language in the Vue I18n instance
          this.$i18n.locale = code;

        } catch (error) {
          console.error("Error switching language:", error);
        }
      },

      onStoreChange(storeId) {
        if (!storeId) return;

        // Save globally
        localStorage.setItem("store_id", storeId);

        // reload and fetch new store id
        window.location.reload();
      },
    },

    mounted() {
      const savedLang = localStorage.getItem("selectedLanguage") || "en";

      if (localStorage.getItem("auth_token")) {
        this.changeLanguage(savedLang);
      } else {
        this.$i18n.locale = savedLang;
        this.currentLanguage = this.languages[savedLang].name;
        this.currentFlag = this.languages[savedLang].flag;
      }
    },

  };
</script>
  
